(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationDefinitionAuthority', CommunicationDefinitionAuthority);

    CommunicationDefinitionAuthority.$inject = ['$resource'];

    function CommunicationDefinitionAuthority ($resource) {
        var resourceUrl =  'api/communication-definition-authorities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByUserAndEntity': { method: 'GET', isArray: true, url: 'api/communication-definition-authorities/:userId/:entityId'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
